interface IQueries {
    sortindFiled?: string | null
    filters?: IFilterCondition[]
    top?: number
    skip?: number
    count?: boolean
}

const onUseQueries = <T extends string, K>(queries: Record<T, K | null>): string => {
    let _queries = {}

    for (const key in queries) {
        if (queries[key]) {
            _queries = { ..._queries, [key]: queries[key] }
        }
    }

    if (!Object.keys(_queries).length) {
        return ''
    }

    return `?${new URLSearchParams(_queries).toString()}`
}

const onUseOdataQueries3 = (queries: IQueries) => {
    const { filters = null, top = null, skip = null, count = false, sortindFiled = null } = queries

    const onHandleFilterResult = (filterString: string | null) => {
        if (filterString) {
            const separated = filterString.split(' ').filter((item) => item !== '')
            const tail = separated[separated.length - 1]
            if (tail === 'and' || tail === 'or') {
                return separated.slice(0, -1).join(' ')
            }
            return filterString
        }
        return null
    }

    const filter = filters
        ? filters.reduce((acc, item) => {
              if (item.isExist) {
                  acc += `${item.filterString}`
                  if (item.conditionParam) {
                      acc += ` ${item.conditionParam} `
                  }
              }
              return acc
          }, '')
        : null

    const resopnse: Record<string, string | number | boolean | null> = {
        $filter: onHandleFilterResult(filter),
        $top: top,
        $skip: skip,
        $count: count,
        $orderBy: sortindFiled ? `${sortindFiled}` : null
    }
    return onUseQueries(resopnse)
}

export interface IFilterCondition {
    filterString: string
    conditionParam?: 'and' | 'or' | null
    isExist: boolean
}

export { onUseOdataQueries3 }
